<template>
  <div>
    <header>
    	<div class="header fix">
    		<img v-on:click="back(false)" :style="{left:left,opacity:opaque}" class="header-icon header-icon-left" src="/static/images/Normal05/back.svg">
    		<a class="header-main" v-text="datas.name"></a>
    		<img v-on:click="back(true)" :style="{right:right,opacity:opaque}" class="header-icon header-icon-right" src="/static/images/Normal05/home.svg">
    	</div>
    </header>

    <div>
      <div v-if="datas.data">
        <div class="product-box">
          <div class="swiper-container banner" v-if="datas.data.img">
          	<div class="swiper-wrapper">
          		<div class="swiper-slide"><img class="img" :src="datas.data.img"></div>
          	</div>
          	<div class="swiper-pagination"></div>
          </div>

          <div class="product-data product-name" v-text="datas.data.name"></div>

          <div class="product-data box-top">
            <div class="product-title">商品属性</div>
            <div class="product-datas">
              <ul>
                <li class="product-datas-left">商品名：</li>
                <li class="product-datas-right" v-text="datas.data.name"></li>
              </ul>
              <ul v-if="datas.data.period">
                <li class="product-datas-left">保质期：</li>
                <li class="product-datas-right" v-text="datas.data.period"></li>
              </ul>
              <ul v-if="datas.data.unit">
                <li class="product-datas-left">规格：</li>
                <li class="product-datas-right" v-text="datas.data.unit"></li>
              </ul>
              <ul v-if="datas.data.introduce">
                <li class="product-datas-left">描述：</li>
                <li class="product-datas-right" v-text="datas.data.introduce"></li>
              </ul>
            </div>
          </div>

          <div class="product-data box-top product-data-details">
            <div class="product-data-main" v-for="item in datas.data.attribute">
              <p v-if="item.key" >
                <a v-if="item.key" v-text="item.key+'：'"></a>
                <a v-text="item.value"></a>
              </p>
              <img v-else class="img" :src="item.value">
            </div>
          </div>

        </div>
      </div>
      <div class="null-box" v-else>
        <div class="null-img"><img src="/static/images/null.png"></div>
        <div class="null-text">内容为空</div>
      </div>
    </div>
  </div>
</template>

<script>
var self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'Details',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      opaque:0.1,
      left:"-50px",
      right:"-50px",
      datas:null
    }
  },
  created () {
    self = this;
    var datas = JSON.parse(localStorage.getItem("wwm_ProductDetails"));
    datas.data.attribute = JSON.parse(datas.data.attribute);
    self.datas = datas;
    $(document).scrollTop(0);

    setTimeout(function () {
      new Swiper('.banner', {
      	autoplay : {
      		delay:5000
      	},
      	loop: true,
      	// autoHeight: true, //高度随内容变化
      	pagination: {
      		el: ".swiper-pagination",
      		clickable: true,
      	}
      })
    },500)

    setTimeout(function(){
      self.opaque = 1;
      self.left = "10px";
      self.right = "10px";
    },10)

  },
  methods:{
    back (state){
      if(state){
        this.$router.push({path: "/Normal05"}); // 模板路由跳转
      }else{
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>
  .img{
    display: block;
    width: 100%;
  }
  .box-top{
    margin-top: 8px;
  }
  header{
    position: relative;
    background-color: #5faf28;
  }
  .header{
    color: #FFF;
    text-align: center;
    font-size: 19px;
    background-color: #5faf28;
    z-index: 99;
  }
  .headerTwo{
    margin-top: 10px;
  }
  .fix{
    position: fixed;
    left:0;top:0;right: 0;
  }
  .header-icon{
    width: 25px;
    position: absolute;
    transition: all .8s ease 0s;
  }
  .header-icon-left{
    left:10px;
    top:15px;
  }
  .header-icon-right{
    right:10px;
    top:13px;
  }
  .header-main{
    padding:15px 0;
    display: block;
    text-align: center;
    margin-left:35px;
    width: calc(100% - 70px);
  }
  .headerOne .header-main,.headerTwo .header-main{
    width: calc(100% - 30px);
    margin-left:15px;
  }
  .null-box{
    padding:20vh 0;
  }
  .null-img img{
    width: 160px;
    display: block;
    margin:0 auto;
  }
  .null-text{
    color:#777;
    font-size: 17px;
    text-align: center;
  }
  .product-box{
    padding-top:55px;
  }
  .product-data{
    padding:10px;
    background-color: #FFF;
    border-bottom: 1px solid #E3E3E3;
  }
  .product-name{
    font-size: 16px;
    padding:15px 10px;
  }
  .product-title{
    padding-top:5px;
    padding-bottom:10px;
    font-size: 16px;
    border-bottom: 1px solid #E3E3E3;
  }
  .product-datas{
    padding-bottom: 10px;
  }
  .product-datas ul{
    overflow: hidden;
  }
  .product-datas ul li{
    float: left;
    padding-top: 12px;
  }
  .product-datas-left{
    width: 80px;
    color:#999;
  }
  .product-datas-right{
    width: calc(100% - 80px);
  }
  .product-data-details{
    padding:15px 10px;
  }
  .product-data-main{
    color:#333;
    padding-bottom: 15px;
  }
  .product-data-main:last-child{
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/public-view/ProductDetails.vue